import { atom } from "recoil";

export const filteredCommunitiesAtom = atom({
  key: "filteredCommunities",
  default: [],
});
